/* axiosのラッパー */
import axios from 'axios';
const instance = axios.create({
  baseURL: process.env.MIX_BASE_URL,
  headers: {
    'Access-Control-Allow-Origin': process.env.MIX_ALLOW_ORIGIN,
    'X-Requested-With': 'XMLHttpRequest',
  },
});

export default instance;
